import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import Message from "@features/shared/components/Message";

const VisitDetails = ({ name }) => {
  const visitData = useSelector((state) =>
    name === "wssPage"
      ? state?.visitDetails?.checkInWSSDetails
      : state?.visitDetails?.checkInDetails
  );

  const visitDetails = useMemo(() => {
    if (!visitData?.length) return [];

    return visitData
      .filter((visit) => visit?.IsValidCheckIn__c !== "Invalid")
      .map((visit) => {
        const date = new Date(visit?.Check_In_Date_Time__c);
        const formattedDate = date?.toLocaleString("en-US", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
        });

        return {
          ...visit,
          Check_In_Date_Time__c: formattedDate,
        };
      });
  }, [visitData]);

  return (
    <div className="px-2 py-2.5">
      <div className="py-2.5 text-[#3901FF] font-semibold text-xl leading-5">
        Visit Details
      </div>
      <div className="w-full bg-white shadow-[0.081rem_0.081rem_0.348rem_rgba(20,20,20,0.07)] rounded-[0.525rem]">
        <div className={visitDetails?.length > 0 ? "p-2.5" : "p-2.5"}>
          <div className="flex justify-between pb-1.5">
            <div className="font-maven font-semibold text-lg leading-4 p-1.5 text-[#808080]">
              Check In history
            </div>
            <div className="flex justify-end">
              <div className="font-maven font-semibold text-[0.84rem] leading-4 text-[#f27042] py-1.5 pr-3.5">
                {visitDetails?.length} Visits
              </div>
            </div>
          </div>

          {visitDetails?.length > 0 ? (
            <>
              <div className="flex justify-between pb-1.5">
                <div className="font-roboto font-medium text-[7.94px] sm:text-[0.684rem] md:text-[0.746rem] leading-[9px] text-[#2B2B2B] px-1.5 py-0.5 w-[4.688rem] sm:w-[7.25rem] md:w-[8.25rem]">
                  {name === "wssPage" ? "WSS Name" : "Dealer Name"}
                </div>
                <div className="font-roboto font-medium text-[7.94px] sm:text-[0.684rem] md:text-[0.746rem] leading-[9px] text-[#2B2B2B] px-1.5 py-0.5 w-[4.688rem] sm:w-[7.25rem] md:w-[8.25rem]">
                  Territory
                </div>
                <div className="font-roboto font-medium text-[7.94px] sm:text-[0.684rem] md:text-[0.746rem] leading-[9px] text-[#2B2B2B] px-1.5 py-0.5 w-[4.688rem] sm:w-[7.25rem] md:w-[8.25rem]">
                  Date
                </div>
              </div>

              <div className="min-h-0 max-h-28 overflow-auto">
                {visitDetails.map((details, index) => (
                  <div key={index} className="flex justify-between">
                    <div className="font-roboto font-medium text-[0.552rem] sm:text-[0.6rem] md:text-[11.83px] leading-[0.9rem] text-[#f27042] px-1.5 py-0.5 w-[4.688rem] sm:w-[7.25rem] md:w-[8.25rem] break-all sm:mb-1.5 md:whitespace-nowrap">
                      {name === "wssPage"
                        ? details?.WSS_Name__c
                        : details?.CheckIn_Dealer__c}
                    </div>
                    <div className="font-roboto font-medium text-[0.552rem] sm:text-[0.6rem] md:text-[11.83px] leading-[0.9rem] text-[#f27042] px-1.5 py-0.5 w-[4.688rem] sm:w-[7.25rem] md:w-[8.25rem] break-all sm:mb-1.5 md:whitespace-nowrap">
                      {details?.MTP_Territory_es__r?.SH2_Name__c}
                    </div>
                    <div className="font-roboto font-medium text-[0.552rem] sm:text-[0.6rem] md:text-[11.83px] leading-[0.9rem] text-[#f27042] px-1.5 py-0.5 w-[4.688rem] sm:w-[7.25rem] md:w-[8.25rem] break-all sm:mb-1.5 md:whitespace-nowrap">
                      {details?.Check_In_Date_Time__c}
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <Message message="No visit details" variant="visitDetails" />
          )}
        </div>
      </div>
    </div>
  );
};

export default VisitDetails;
